import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { AppState } from '../../state';
import * as CognitoAuthActions from './cognito-auth.actions';
import * as CognitoAuthSelectors from './cognito-auth.selectors';

@Injectable({
  providedIn: 'root'
})
export class CognitoAuthFacade {
  public readonly isAuthenticated$ = this.store.pipe(
    select(CognitoAuthSelectors.selectIsAuthenticated)
  );

  public readonly signInWithMagicLinkSuccess$ = this.actions$.pipe(
    ofType(CognitoAuthActions.signInWithMagicLinkSuccess),
    map(() => true)
  );

  public readonly confirmSignInWithMagicLinkSuccess$ = this.actions$.pipe(
    ofType(CognitoAuthActions.confirmSignInWithMagicLinkSuccess)
  );

  public readonly userId$ = this.store.pipe(
    select(CognitoAuthSelectors.selectUserId)
  );

  public readonly isInProgress$ = this.store.pipe(
    select(CognitoAuthSelectors.selectIsInProgress)
  );

  constructor(
    private store: Store<AppState>,
    private actions$: Actions
  ) {}

  public signinWithGoogle(): void {
    this.store.dispatch(CognitoAuthActions.signinWithGoogle());
  }

  public signinWithLinkedIn(): void {
    this.store.dispatch(CognitoAuthActions.signinWithLinkedIn());
  }

  public signInWithMagicLink(email: string): void {
    this.store.dispatch(CognitoAuthActions.signInWithMagicLink({ email }));
  }

  /** AUTH.7. Spend an emailed link, on the person's press of "Continue". */
  public confirmSignInWithMagicLink(token: string, email: string): void {
    this.store.dispatch(
      CognitoAuthActions.confirmSignInWithMagicLink({ token, email })
    );
  }

  public signOut(): void {
    this.store.dispatch(CognitoAuthActions.signOut());
  }

  public checkAuthenticationStatus(): void {
    this.store.dispatch(CognitoAuthActions.checkAuthenticationStatus());
  }
}
